import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Modal from 'react-responsive-modal';

class DadosCliente extends Component {

  constructor(props) {
    super(props);

    this.state = {
      parcela: {},
      parcelas: [],
      checked: false,
      checkedBoxes: [],
      checkedParcelas: {},
      checkedParcela: [],
      view: false,
      parcelaAberto: {},
      parcelasAberto: [],
      numped: 0,
      codfil: 0,
      open: false,
      estados: [],
      expandir: false,
      width: window.innerWidth,
      marginLeft: '0',
      showBoleto: false,
      modalBtnAndroid: false,
      modalBtnIOS: false,
      helpUser: 'none',
      btnhelpUser: true,
      genButtonState: 'Carregando... ',
      disableGenButton: true
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
    this.handleGenButtonState();

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleGenButtonState() {
    setTimeout(() => this.setState({
      genButtonState: 'Gerar Boleto(s)',
      disableGenButton: false
    })
      , 3000);

  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };


  async componentDidMount() {
    await this.getParcelas();
  }

  verifyHelpState = () => {
    // console.log("testando")
    if (this.state.helpUser === true) {
      // console.log("if true")
      this.setState({
        helpUser: 'none',
        btnhelpUser: true
      })
    }
    if (this.state.helpUser === 'none') {
      // console.log("if none")
      this.setState({
        helpUser: true,
        btnhelpUser: 'none'
      })
    }
  }

  async changeParcelsState(parcelasAberto) {

    //await this.setState({codfil: parcelasAberto.CODFIL} );

    // É considerado numero(no check do if) , depois passado pra string pra manipulação e tirar os 0's a esquerda
    //console.log("Valor do checkbox clicado:" + parcelasAberto.DESDTIT)

    let parcelas = this.state.parcelaAberto;

    /*parcelas.map(p => {
      if (p === parcelasAberto)
         p.SELECTED = !p.SELECTED;
    });*/

    parcelas.forEach(p => {
      if (p === parcelasAberto)
        p.SELECTED = !p.SELECTED;
    })



    await this.setState({ parcelaAberto: parcelas });

    /*
          let checkedBoxes = "";
          checkedBoxes = this.state.checkedBoxes
          //console.log("checkboxes" + checkedBoxes);
          for(var i = 0 ; i < checkedBoxes.length; i++){
            if( checkedBoxes[i] > 9){
              checkedBoxes[i] = parseInt(checkedBoxes[i]);
              //console.log("checkboxes after" + checkedBoxes[i]);
            }
          } // octal to binary
    
          //console.log("checkboxes after" + checkedBoxes);
          checkedBoxes = checkedBoxes.toString();
          var  DESDTIT_WithoutZero = parcelasAberto.DESDTIT.toString();
          DESDTIT_WithoutZero = parseInt(DESDTIT_WithoutZero)
          //console.log("Found any ?" + checkedBoxes.indexOf(DESDTIT_WithoutZero))
    
          if(checkedBoxes.indexOf(DESDTIT_WithoutZero) === -1){ // nao encontrado
            //console.log("checkboxes nao encontrado " + checkedBoxes);
            await this.setState({checkedBoxes : this.state.checkedBoxes + "," + parcelasAberto.DESDTIT});
          }
    
          if(checkedBoxes.indexOf(DESDTIT_WithoutZero) !== -1){ // encontrado
            //console.log("checkboxes encontrado " + checkedBoxes);
            checkedBoxes = this.state.checkedBoxes;
            checkedBoxes = checkedBoxes.replace(','+parcelasAberto.DESDTIT,'')
            await this.setState({checkedBoxes : checkedBoxes});
          }
          // await console.log("Persistindo o array com set state: " + this.state.checkedBoxes)
    
          //console.log(this.state.checkedBoxes);
          */
  }

  getBoletoParcelas = () => {

    /*//console.log("Desformatado: " + this.state.checkBoxes);
    var checkBoxesFormatted = this.state.checkedBoxes;
    for(var i = 0 ; i < checkBoxesFormatted.length; i++){
      if( checkBoxesFormatted[i] > 9){
        checkBoxesFormatted[i] = parseInt(checkBoxesFormatted[i]);
        //console.log("checkboxes after" + checkBoxesFormatted[i]);
      }
    }*/

    let parcelas = ""

    this.state.parcelaAberto.forEach(p => {
      if (p.SELECTED) {
        parcelas = parcelas + "," + p.DESDTIT
      }
    })

    /*
        checkBoxesFormatted = checkBoxesFormatted.toString();
    
        checkBoxesFormatted = checkBoxesFormatted.replace(",","")
    
    
    //    checkBoxesFormatted
    
    
    
         var parcelas = numberToFormat;*/
    let numberToFormat = parcelas.split(',')
    numberToFormat = numberToFormat.toString().replace(',', '')

    parcelas = numberToFormat.split(",").join("-")

    this.setState({ parcelas })
    //console.log("CODFIL: " + this.state.codfil)
    //console.log("NUMPED: " + this.state.numped)
    //console.log("Parcelas: " + parcelas)
    if (parcelas === "") {
      toast.error(`Assinale pelo menos uma caixa de confirmação!`);
      //console.log("checkboxes are null")
    }
    else {

      var linkEnvioBoleto = "http://arcos.zema.com/COM.FIL.ImpressosZema/BoletoEletrozema.aspx?codfil=" + this.state.codfil + "&numped=" + this.state.numped + "&parc=" + parcelas
      // console.log("Link: " + linkEnvioBoleto)
      //console.log(this.setState({linkEnvioBoleto: linkEnvioBoleto}))

      setTimeout(() => window.open(linkEnvioBoleto), 500);

    }
  }

  async copiaLinhaDigitavel(parcelas) {

    try {

      var textField = document.createElement('textarea');
      textField.innerText = parcelas.LINHA_DIGITAVEL;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      textField.remove();

      toast.success(`Copiado para Área de Transferência`);

    }
    catch (err) {
      toast.error(`Erro ao copiar`);
    }

  }

  clearAllBoxes = event => {
    event.preventDefault()
    let parcelas = this.state.parcelaAberto;

    parcelas.forEach(p => {
      p.SELECTED = false;
    })

    this.setState({ parcelaAberto: parcelas });
  }

  checkAllBoxes = event => {
    event.preventDefault()

    let parcelas = this.state.parcelaAberto;

    parcelas.forEach(p => {
      p.SELECTED = true;
    })
    //this.setState({codfil: parcelasAberto[0].CODFIL} );

    this.setState({ parcelaAberto: parcelas });
  }



  async getExpandir(parcelas) {

    this.setState({ checkedBoxes: "" })

    const URL = `${process.env.REACT_APP_API_URL}/api/boletopwa/parcela/${this.props.login.user.CGCCPF}/${parcelas.NUMPED}`;
    const HEADER = new Headers({
      Accept: "application/json",
      Authorization: `Bearer ${this.props.login.token}`
    });

    await fetch(URL, { method: "GET", headers: HEADER })
      .then(response => response.json())
      .then(parcelasAberto => {

        if (parcelasAberto.length > 0) {

          parcelasAberto.forEach(p => {
            p.SELECTED = false;
          })

          this.setState({
            parcelaAberto: parcelasAberto,
            codfil: parcelasAberto[0].CODFIL,
            view: true,
            numped: parcelasAberto[0].NUMPED
          });
        }

      })
      .catch(err => {
        toast.error(err);
      })

    //console.log(this.state);
  }

  getParcelas = async () => {

    const URL = `${process.env.REACT_APP_API_URL}/api/boletopwa/boletozema/${this.props.login.user.CGCCPF}`;
    const HEADER = new Headers({
      Accept: "application/json",
      Authorization: `Bearer ${this.props.login.token}`
    });

    await fetch(URL, { method: "GET", headers: HEADER })
      .then(response => response.json())
      .then(parcelas => {

        if (parcelas.length > 0) {

          this.setState({ parcela: parcelas });

        }
      })
      .catch(err => {
        toast.error(err);
      })
  }

  render() {
    const { width } = this.state;
    const isMobile = width <= 500;

    return (
      <div className="cartClient">
        <h2>{this.props.login.user.NOMCLI}</h2>
        <hr />
        <h2>Pedido(s) em aberto:</h2>
        {
          this.state.parcela.length > 0 ?

            <table className="table-clientes">
              <thead>
                <tr>
                  <th>Pedido</th>
                  <th>Data Pedido</th>
                  <th>Próximo Vencimento</th>
                  <th>Valor Parcela</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.parcela.map(parcelas => {
                    return (
                      <tr key={parcelas.CODFIL}>
                        <td>{parcelas.NUMPED}</td>
                        <td>{parcelas.DTEMISSAO}</td>
                        <td>{parcelas.DTVENCTO}</td>
                        <td>{parcelas.VLORIG}</td>
                        <td><button className="btn btn-primary" style={{ backgroundColor: '#2eb82e', border: 'none' }} onClick={this.getExpandir.bind(this, parcelas)}>{

                          isMobile ? '+' : 'Expandir'

                        }</button></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
            :
            <h6>Você não possui parcelas em aberto. <p>Clique <a href="https://www.zema.com" style={{ color: 'blue' }}>aqui</a> para aproveitar nossas ofertas! ;)</p></h6>

        }

        <div style={{ display: this.state.view === true ? 'inline' : 'none' }}>
          <hr />
          <h2>Pedido {this.state.numped}</h2>


          <div className="">

            {
              this.state.parcelaAberto.length > 0 ?

                <table className="table-clientes">
                  <thead>
                    <tr>

                      <th>Parcela</th>
                      <th>Vencimento</th>
                      <th>Valor</th>
                      <th>
                        {
                          isMobile ? 'Linha' : 'Selecionar'
                        }
                        < p >
                          {isMobile ? 'Digitável' : null}
                        </ p >
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      this.state.parcelaAberto.map(parcelasAberto => {
                        return (
                          <tr key={parcelasAberto.ID}>

                            <td>{parcelasAberto.DESDTIT}</td>
                            <td>{parcelasAberto.DTVENCTO}</td>
                            <td>{parcelasAberto.VLORIG}</td>
                            {
                              isMobile ?
                                <div>
                                  <td> <button className="btn btn-primary" style={{ backgroundColor: '#2eb82e', border: 'none' }} onClick={this.copiaLinhaDigitavel.bind(this, parcelasAberto)}>Copiar</button></td>
                                  <td> <input type="checkbox" name="checkBoxParcel" value={parcelasAberto.SELECTED} checked={parcelasAberto.SELECTED} onClick={this.changeParcelsState.bind(this, parcelasAberto)} style={{ marginLeft: 26.5 }} /></td>
                                </div>
                                :
                                <td> <input type="checkbox" name="checkBoxParcel" value={parcelasAberto.SELECTED} checked={parcelasAberto.SELECTED} onClick={this.changeParcelsState.bind(this, parcelasAberto)} style={{ marginLeft: 33.5 }} /></td>

                            }

                          </tr>
                        )
                      })
                    }
                  </tbody>
                </table>
                :
                <h6>Você não possui parcelas em aberto. <p>Clique <a href="https://www.zema.com" style={{ color: 'blue' }}>aqui</a> para aproveitar nossas ofertas! ;)</p></h6>

            }


          </div>
          <div>
            <div style={{ marginTop: '3%', marginLeft: '35.5%' }}>
              <button type="submit" className="_btn _btn--success" onClick={this.checkAllBoxes}>Marcar Todos</button>
              <button style={{ marginTop: '3%' }} type="submit" className="_btn _btn--success" onClick={this.clearAllBoxes}>Limpar Todos</button>
              {

                <button style={{ marginTop: '3%' }} type="submit" className="_btn _btn--success" onClick={this.getBoletoParcelas} disabled={this.state.disableGenButton}> {this.state.genButtonState} </button>
              }
            </div>
          </div>
          {


            !isMobile ?
              null
              :
              <div>
                <div style={{ marginTop: '3%', marginLeft: '0%' }}>

                  <br />
                  <br />
                  <h5> &nbsp; Não consegue gerar os boletos no seu celular? </h5>
                  <br />
                  <div style={{ display: this.state.btnhelpUser }}>
                    <button style={{ marginTop: '3%' }} type="submit" className="_btn _btn--success" onClick={this.verifyHelpState}>Clique Aqui!</button>
                  </div>

                  <div style={{ display: this.state.helpUser }}>

                    <p> &nbsp; Verifique se o seu navegador está com os pop-ups desativados. </p>
                    <p> &nbsp; Para prosseguir, selecione seu Sistema Operacional: </p>

                    <button
                      className="_btn _btn--success"
                      onClick={() => this.setState({ modalBtnAndroid: true })}>
                      <font color="white"> Android </font>
                    </button>

                    <button
                      className="_btn _btn--success"
                      onClick={() => this.setState({ modalBtnIOS: true })}>
                      <font color="white"> iOS </font>
                    </button>
                    < br />
                    < br />
                    <button
                      className="_btn _btn--success"
                      onClick={this.verifyHelpState}>
                      <font color="white"> Ocultar </font>
                    </button>

                  </div>


                </div>
              </div>

          }

        </div>
        <Modal open={this.state.modalBtnAndroid} onClose={() => { this.setState({ modalBtnAndroid: false }) }} center closeOnEsc={false} closeOnOverlayClick={false}>
          <div style={{ paddingTop: "15%", backgroundColor: '#CDFFE4' }} className="login__box_forgot_pass_modal">


            <h5>No smartphone ou tablet Android: </h5>

            < br />
            <h5><center>Google Chrome</center></h5>
            < br />

            <p>1- Abra o app do Chrome. </p>
            <p>2- À direita da barra de endereço, toque em Mais Configurações. </p>
            <p>3- Toque em Configurações do site Pop-ups e redirecionamentos. </p>
            <p>4- Selecione Permitidos ou Bloqueados para a opção Pop-ups e redirecionamentos. </p>

            < br />

            <button
              className="btn btn-exit"
              style={{ backgroundColor: '#cc1f1a' }}
              onClick={() => this.setState({ modalBtnAndroid: false })}>
              <font color="white"> Sair </font>
            </button>


          </div>
        </Modal>

        <Modal open={this.state.modalBtnIOS} onClose={() => { this.setState({ modalBtnIOS: false }) }} center closeOnEsc={false} closeOnOverlayClick={false}>
          <div style={{ paddingTop: "15%", backgroundColor: '#CDFFE4' }} className="login__box_forgot_pass_modal">

            <h5>No iPhone ou iPad:</h5>

            < br />
            <h5><center>Google Chrome</center></h5>
            < br />
            <p>1- Toque em Mais Configurações . </p>
            <p>2- Toque em Configurações de conteúdo Bloquear pop-ups. </p>
            <p>3- Desative a opção Bloquear pop-ups. </p>

            < br />
            <h5><center>Safari</center></h5>
            < br />
            <p>1- Acesse “Ajustes” no seu iPhone e em seguida toque em “Safari” . </p>
            <p>2- Em “Geral”, toque na chave ao lado de “Bloquear Pop-ups” para o modo "Desativado" (em cinza). </p>

            < br />

            <button
              className="btn btn-exit"
              style={{ backgroundColor: '#cc1f1a' }}
              onClick={() => this.setState({ modalBtnIOS: false })}>
              <font color="white"> Sair </font>
            </button>

          </div>
        </Modal>

      </div>
    );
  }
}

const mapStateToProps = state => ({ login: state.login });

export default connect(mapStateToProps)(DadosCliente);



// WEBPACK FOOTER //
// ./src/Views/Venda/dadosCliente.js